<div class="w3-container w3-margin">
  <section class="invoice">
    <div class="row w3-blue w3-padding-16"></div>
    <div class="row w3-pale-blue">
      <div class="col-12">
        <h3 class="page-header w3-center ggPrompt">
          <i class="fas fa-globe"></i> ฝ่ายจัดหาวัตถุดิบ
          <!-- <small class="float-right w3-small">Date: 2/10/2014</small> -->
        </h3>
      </div>
      <div class="col-12 w3-center">
        <span class="w3-large prompt-regular">
          รายงานประจำวันที่ 10 ธันวาคม 2567
        </span>
      </div>
    </div>

    <div class="row w3-pale-blue">
      <div class="col-12 table-responsive">
        <table class="table table-striped w3-card-4 prompt-regular">
          <thead>
            <tr class="prompt-semibold">
              <th>#</th>
              <th class="w3-right-align">เป้าหมาย</th>
              <th class="w3-right-align">วันนี้</th>
              <th class="w3-right-align">สะสม</th>
              <th class="w3-center">%</th>
            </tr>
          </thead>
          <tbody>
            <tr class="prompt-bold">
              <th colspan="5"><i class="fas fa-chart-line"></i> เชิงปริมาณ</th>
            </tr>
            <tr>
              <td style="padding-left: 15px;">พื้นที่ปลูก(ไร่)</td>
              <td class="w3-right-align">225,000.00</td>
              <td class="w3-right-align">205,122.15</td>
              <td class="w3-right-align">205,122.15</td>
              <td class="w3-center">%85.25</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">อ้อยเข้าหีบ(ตัน)</td>
              <td class="w3-right-align">2,255,000.00</td>
              <td class="w3-right-align">15,122.15</td>
              <td class="w3-right-align">35,122.15</td>
              <td class="w3-center">%3.25</td>
            </tr>
            <tr>
              <td style="padding-left: 15px;">แปลงตัดเสร็จ(ไร่)</td>
              <td class="w3-right-align">225,000.00</td>
              <td class="w3-right-align">1,122.15</td>
              <td class="w3-right-align">5,122.15</td>
              <td class="w3-center">%5.25</td>
            </tr>
            <tr class="prompt-bold">
              <th colspan="5"><i class="fas fa-award"></i> เชิงคุณภาพ</th>
            </tr>
          </tbody>
        </table>
      </div>

    </div>


  </section>
</div>
